// Vendor imports
const PropTypes = require('prop-types')
const classNames = require('classnames')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('Button')

function Button(props) {
  const {
    className,
    children,
    forwardedRef: ref,
    title,
    onClick
  } = props
  const {
    tagName,
    disabled,
    href,
    target,
    type
  } = derivedButtonProps(props)
  return tag(tagName, {
    className: classNames(
      className,
      bem.block({ disabled })
    ),
    disabled,
    href,
    ref,
    target,
    title,
    type,
    onClick
  },
    children
  )
}

Button.propTypes = {
  // Values
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  forwardedRef: PropTypes.func,
  href: PropTypes.string,
  target: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
  // Callbacks
  onClick: PropTypes.func
}

Button.withButton = className => {
  const highOrderComponent = props => {
    return tag(Button, {
      ...props,
      className: classNames(className, props.className)
    })
  }
  highOrderComponent.displayName = `withButton(${className})`
  highOrderComponent.propTypes = Button.propTypes
  return highOrderComponent
}

module.exports = Button

function derivedButtonProps(props) {
  if (props.href && !props.disabled) {
    return {
      tagName: 'a',
      href: props.href,
      target: props.target
    }
  }
  return {
    tagName: 'button',
    type: props.type || 'button',
    disabled: !!props.disabled
  }
}
